.welcome {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-6);
  padding: var(--tuna-spacing-4);
}

.intro {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.title {
  font-size: var(--tuna-typography-h2-fontSize);
  margin: 0;
}

.tagline {
  color: var(--tuna-content-secondary);
  margin: 0;
}

.subModeGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--tuna-spacing-3);
}

.subModeCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: var(--tuna-spacing-4);
  min-height: 120px;
}

.subModeCard[aria-pressed='true'] {
  outline: 2px solid var(--tuna-palette-primary-500);
  outline-offset: 2px;
}

.cardTitle {
  font-size: var(--tuna-typography-h3-fontSize);
  font-weight: 600;
  margin-bottom: var(--tuna-spacing-1);
}

.cardBody {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body-fontSize);
}

.formGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--tuna-spacing-2);
}

.formCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: var(--tuna-spacing-3);
  min-height: 96px;
}

.formCard[aria-pressed='true'] {
  outline: 2px solid var(--tuna-palette-primary-500);
  outline-offset: 2px;
}

.formCardShort {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.formCardTitle {
  font-size: var(--tuna-typography-body-fontSize);
  font-weight: 600;
}

.formCardBody {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-caption-fontSize);
}
